// import { normalizeTransactionsData } from "./Normalizers";
import useCallAxios from "./useCallAxios";

const filterQuery = (values) => ({ ...values });

export const usevalutAccount = () => {
  const context = `valutAccounts`;
  const { requestSuccess, requestData, requestLoading, fetchGET, requestMessage } =
    useCallAxios({
      context,
    });

  const handleGET = (params) =>
    fetchGET({ context, queryParameters: filterQuery(params), showToast: false });

  return {
    loading: requestLoading,
    state: requestData.data,
    success: requestSuccess,
    message: requestMessage,
    handleGET,
  };
};
